import { css as d, LitElement as v, nothing as h, html as p } from "lit";
import { property as s, customElement as m } from "lit/decorators.js";
import { b as f } from "./styles-scZ6dVz-.js";
var g = Object.defineProperty, b = Object.getOwnPropertyDescriptor, r = (c, i, o, a) => {
  for (var e = a > 1 ? void 0 : a ? b(i, o) : i, l = c.length - 1, n; l >= 0; l--)
    (n = c[l]) && (e = (a ? n(i, o, e) : n(e)) || e);
  return a && e && g(i, o, e), e;
};
let t = class extends v {
  constructor() {
    super(...arguments), this.sectionTitle = "", this.subtitle = "", this.size = "default", this.divider = !1, this.flush = !1;
  }
  render() {
    return p`
      <div part="header" class="header">
        <div part="content" class="content">
          ${this.sectionTitle ? p`<h2 part="title" class="title">${this.sectionTitle}</h2>` : h}
          ${this.subtitle ? p`<span part="subtitle" class="subtitle">${this.subtitle}</span>` : h}
          <slot></slot>
        </div>
        <div part="actions" class="actions">
          <slot name="actions"></slot>
        </div>
      </div>
    `;
  }
};
t.styles = [
  f,
  d`
      :host {
        display: block;
      }

      .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: var(--r5-space-4);
        margin-bottom: var(--r5-space-4);
      }

      .content {
        display: flex;
        align-items: baseline;
        gap: var(--r5-space-2);
        min-width: 0;
        flex-wrap: wrap;
      }

      .title {
        font-size: var(--r5-text-lg);
        font-weight: var(--r5-font-semibold);
        color: var(--r5-text);
        line-height: var(--r5-leading-tight);
        margin: 0;
      }

      .subtitle {
        font-size: var(--r5-text-sm);
        color: var(--r5-text-muted);
        line-height: var(--r5-leading-normal);
        margin: 0;
      }

      .actions {
        display: flex;
        align-items: center;
        gap: var(--r5-space-2);
        flex-shrink: 0;
      }

      /* Size variants */
      :host([size='sm']) .title {
        font-size: var(--r5-text-base);
      }

      :host([size='sm']) .subtitle {
        font-size: var(--r5-text-xs);
      }

      :host([size='sm']) .header {
        margin-bottom: var(--r5-space-3);
      }

      :host([size='lg']) .title {
        font-size: var(--r5-text-xl);
      }

      /* With divider */
      :host([divider]) .header {
        padding-bottom: var(--r5-space-3);
        border-bottom: 1px solid var(--r5-border);
      }

      /* No margin variant */
      :host([flush]) .header {
        margin-bottom: 0;
      }
    `
];
r([
  s({ type: String })
], t.prototype, "sectionTitle", 2);
r([
  s({ type: String })
], t.prototype, "subtitle", 2);
r([
  s({ type: String, reflect: !0 })
], t.prototype, "size", 2);
r([
  s({ type: Boolean, reflect: !0 })
], t.prototype, "divider", 2);
r([
  s({ type: Boolean, reflect: !0 })
], t.prototype, "flush", 2);
t = r([
  m("ark-section-header")
], t);
export {
  t as A
};
//# sourceMappingURL=ark-section-header-DTpNnQoy.js.map
